export const LeaveTypeColumnConfig = {
    LEAVE_TIME_ONLY: window.__GENERATED_CONSTANTS__.LeaveTypeColumnConfig.LEAVE_TIME_ONLY,
    BALANCES_ONLY: window.__GENERATED_CONSTANTS__.LeaveTypeColumnConfig.BALANCES_ONLY,
    LEAVE_TIME_AND_BALANCES: window.__GENERATED_CONSTANTS__.LeaveTypeColumnConfig.LEAVE_TIME_AND_BALANCES
}

export const LeaveTypeBalanceQualifier = {
    SICK_DAYS_ONLY: window.__GENERATED_CONSTANTS__.LeaveTypeBalanceQualifier.SICK_DAYS_ONLY,
    PTO_ONLY: window.__GENERATED_CONSTANTS__.LeaveTypeBalanceQualifier.PTO_ONLY,
    PTO_AND_SICK_DAYS: window.__GENERATED_CONSTANTS__.LeaveTypeBalanceQualifier.PTO_AND_SICK_DAYS
}


// WEBPACK FOOTER //
// ./web/js/reports/leavesReport/LeaveReportConfig.js